export default "__VITE_ASSET__228faa88__"